<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <!-- breadcrumbs -->
            <fragment>
                <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            </fragment>
            <!-- //breadcrumbs -->
            <h2 class="pg_title">
                {{ pageTitle }}
            </h2>
            <!-- //contents_head -->

            <!-- srchTop_wrap -->
            <div class="srchTop_wrap srchFaq_wrap pb20">
                <article class="srch_basic">
                    <dl class="dl_search">
                        <dd class="clearable" data-input-type="input">
                            <input type="text" class="text_input w100p" v-clearable v-model="searchName" />
                        </dd>
                        <dd class="btn">
                            <a href="javascript:" class="btn_srch" @click="onSearch(1)">
                                {{ $t('BUTTON.GLOBAL.SEARCH') }}
                            </a>
                        </dd>
                    </dl>
                    <div class="top_mobile">
                        <dl class="dl_select">
                            <dd data-input-type="select">
                                <select class="slt_white w100" v-model="searchStep">
                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                    <option v-for="item in stepList" :key="pageName + item.code" :value="item.code">
                                        {{ item.codeName }}
                                    </option>
                                </select>
                            </dd>
                        </dl>
                        <dl class="dl_select">
                            <dd data-input-type="select">
                                <select class="slt_white w100" v-model="searchType">
                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                    <option
                                        v-for="item in searchTypeList"
                                        :key="pageName + item.code"
                                        :value="item.code"
                                    >
                                        {{ item.codeName }}
                                    </option>
                                </select>
                            </dd>
                        </dl>
                    </div>
                </article>
            </div>
            <!-- Grid -->
            <div class="grid_wrap">
                <!-- Count -->
                <div class="grid_total">
                    {{ $t('TITLE.TOTAL.COUNT') }} <em>{{ totalCount }}</em>
                </div>
                <div class="btn_wrap" v-if="'Y' === params.creationYn">
                    <a href="javascript:" class="btn_gray" @click="pageMove('toolManageDetail')">
                        {{ $t('BUTTON.GLOBAL.CREATE') }}
                    </a>
                </div>
                <!-- Grid -->
                <toast-grid
                    :gridId="gridId"
                    :columns="columns"
                    :data="gridData"
                    :options="options"
                    :ref="gridId"
                    :key="gridKey"
                    :isTotalCount="false"
                    :click="contentClick"
                />
                <div class="paginate">
                    <sdl-pagination
                        align="center"
                        :current-page="currentPage"
                        :total-rows="totalCount"
                        :per-page="nRecordsPerPage"
                        @change="onSearch"
                    />
                </div>
            </div>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import SDLUtil from '@/utils/SDLUtil';
import { mapActions, mapGetters } from 'vuex';

import ToastGrid from '~c/ToastGrid';
import SDLPagination from '~~c/control/pagination/Pagination';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

export default {
    name: 'toolManageList',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'toast-grid': ToastGrid,
        'sdl-pagination': SDLPagination,
    },
    data() {
        return {
            pageName: 'toolManageList',
            pageTitle: '',
            searchStep: 'O',
            stepList: [],
            searchType: 'Release',
            searchTypeList: [],
            searchName: '',
            reqSystem: '',
            totalCount: 0,
            currentPage: 1,
            nRecordsPerPage: Number(localStorage.getItem('listRows')),
            gridKey: 0,
            gridId: 'toolManageListGrid',
            columns: [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBJECT'),
                    name: 'TITLE',
                    align: 'center',
                    // width: 125,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.VERSION'),
                    name: 'VERSION',
                    align: 'center',
                    // width: 75,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.FAST.ADDEDBY'),
                    name: 'REG_NAME',
                    align: 'center',
                    // width: 75,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.DATE'),
                    name: 'REG_DATE',
                    align: 'center',
                    // width: 375,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.STEP'),
                    name: 'STEP_NAME',
                    align: 'center',
                    // width: 175,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.STATUS'),
                    name: 'COLOR_STATUS_NM',
                    align: 'center',
                    // width: 175,
                    resizable: true,
                    sortable: false,
                },
            ],
            gridData: [],
            options: {
                scrollY: true,
                scrollX: true,
                minBodyHeight: 80,
                bodyHeight: 450,
            },
        };
    },
    mounted() {
        let title = this.pageTitle.split(' ');
        this.reqSystem = title[0];

        if (!['GD', 'VD', 'HASS'].includes(this.reqSystem)) {
            this.$router.push('/');
        }

        this.getCommonHardCodeList('TOOL_STEP').then(resp => {
            this.stepList = resp;
        });
        this.getCommonHardCodeList('TOOL_STATUS').then(resp => {
            this.searchTypeList = resp;
        });
        this.onSearch(1);
    },
    computed: {
        ...mapGetters({
            deptLevelCd: 'getDeptLevelCd',
            curLoginNo: 'getLoginNo',
            roles: 'getRoles',
            menus: 'getMenus',
            params: 'getParams',
        }),
    },
    methods: {
        async onSearch(v) {
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/admin/tool/toolList.skp`,
                    qs.stringify({
                        page: v,
                        reqSystem: this.reqSystem,
                        searchStep: this.searchStep,
                        searchType: this.searchType,
                        searchName: this.searchName,
                    }),
                )
                .then(resp => {
                    this.gridData = resp.data.result.rowData;

                    for (const iterator of this.gridData) {
                        let code = iterator.STEP;
                        const index = this.stepList.findIndex(v => v.code === code);
                        iterator.STEP_NAME = this.stepList[index].codeName;

                        if ('Draft' === iterator.STATUS) {
                            iterator.COLOR_STATUS_NM = '<span class="txt_draft">' + iterator.STATUS + '</span>';
                        } else if ('Ongoing' === iterator.STATUS) {
                            iterator.COLOR_STATUS_NM = '<span class="txt_commented">' + iterator.STATUS + '</span>';
                        } else if ('Processing' === iterator.STATUS) {
                            iterator.COLOR_STATUS_NM = '<span class="txt_answered">' + iterator.STATUS + '</span>';
                        } else {
                            iterator.COLOR_STATUS_NM = '<span class="">' + iterator.STATUS + '</span>';
                        }
                    }
                    this.totalCount = resp.data.search.totalRecords;
                    this.currentPage = Number(resp.data.search.page);
                    this.gridKey++;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        pageMove(v, step, toolId) {
            return this.$router.push({
                path: '/basis/admin/tool/' + v,
                query: { reqSystem: this.reqSystem, reqStep: SDLUtil.nvl(step, 'Q'), reqToolId: SDLUtil.nvl(toolId) },
            });
        },
        async getCommonHardCodeList(v) {
            const codeResp = await api.getCommonHardCodeList(v);
            return codeResp;
        },
        contentClick(e, rowData, grid) {
            this.pageMove('toolManageDetail', rowData[e.rowKey]['STEP'], rowData[e.rowKey]['TOOL_ID']);
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/tool/toolManageList.vue